// extracted by mini-css-extract-plugin
export default {"presentWrapper":"Prize_presentWrapper__5uZ6H","present":"Prize_present__YieDc","prize":"Prize_prize__DV6BF","left":"Prize_left__6Qwm3","right":"Prize_right__6u+uZ"};